import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';

type ConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onCancel: () => void;
  onConfirm: () => void;
  header?: string;
  body?: string;
  confirmLabel?: string;
  cancelLabel?: string;
};

export function ConfirmationModal({
  isOpen,
  onClose,
  onCancel,
  onConfirm,
  header = 'Confirm Reset Form',
  body = 'Are you sure you want to reset the entire form?',
  confirmLabel = 'Reset',
  cancelLabel = 'Cancel',
}: ConfirmationModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{header}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{body}</ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button bg={'blue.700'} onClick={onConfirm} color={'white'}>
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
